<template>
    <div id="app">
      <div class="brand-backdrop" aria-hidden="true">
      </div>
      <div class="inner">
        <router-view/>
        <MainFooter/>
      </div>
    </div>
</template>

<script>
import MainFooter from '@/components/MainFooter.vue'

export default {
    components: {
        MainFooter,
    }
}
</script>


<style>
:root {
  --ss-ink: #16140f;
  --ss-muted: #69665c;
  --ss-line: #242118;
  --ss-page: #fff7dc;
  --ss-panel: #fffdf4;
  --ss-yellow: #ffd84d;
  --ss-orange: #ff8f2f;
  --ss-green: #44d46b;
  --ss-blue: #3d6bff;
  --ss-red: #ff5a4f;
  --ss-shadow: 0 18px 0 rgba(22, 20, 15, 0.11), 0 24px 40px rgba(22, 20, 15, 0.12);
}

* {
  box-sizing: border-box;
}

html,
body {
  min-height: 100%;
}

body {
  margin: 0;
  background:
    radial-gradient(circle at 12% 12%, rgba(255, 216, 77, 0.75), transparent 28rem),
    radial-gradient(circle at 88% 20%, rgba(68, 212, 107, 0.35), transparent 24rem),
    linear-gradient(180deg, #fff4c2 0%, #fff9e6 42%, #f5ffe8 100%);
  color: var(--ss-ink);
}

#app {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--ss-ink);
}

.inner {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  padding-bottom: 6.5rem;
}

.brand-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.brand-backdrop::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(22, 20, 15, 0.045) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 20, 15, 0.045) 1px, transparent 1px);
  background-size: 38px 38px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.85), transparent 78%);
}

.page-shell {
  width: min(1120px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 2.5rem 0 1.5rem;
}

.page-shell.narrow {
  width: min(640px, calc(100% - 2rem));
}

.site-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--ss-ink);
  font-size: clamp(1.15rem, 4vw, 1.45rem);
  font-weight: 900;
}

.site-logo img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.brand-kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.75rem;
  padding: 0.35rem 0.7rem;
  border: 2px solid var(--ss-line);
  border-radius: 999px;
  background: var(--ss-green);
  color: var(--ss-ink);
  font-size: 0.76rem;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;
}

.brand-title {
  margin: 0;
  color: var(--ss-ink);
  font-size: clamp(2.4rem, 7vw, 4.9rem);
  font-weight: 950;
  line-height: 0.92;
  letter-spacing: 0;
}

.brand-subtitle {
  max-width: 45rem;
  margin: 1rem auto 0;
  color: var(--ss-muted);
  font-size: 1.08rem;
  font-weight: 650;
  line-height: 1.55;
}

.brand-panel,
.card,
.modal-content {
  border: 2px solid var(--ss-line) !important;
  border-radius: 8px !important;
  background: var(--ss-panel) !important;
  color: var(--ss-ink);
  box-shadow: var(--ss-shadow) !important;
}

.card-header {
  border-bottom: 2px solid var(--ss-line) !important;
  background: var(--ss-yellow) !important;
  color: var(--ss-ink) !important;
  font-weight: 900;
}

.card-header h4,
.card-header h5,
h1,
h2,
h3,
h4,
h5 {
  color: var(--ss-ink);
  font-weight: 900;
  letter-spacing: 0;
}

a {
  color: #11682b;
  font-weight: 850;
}

a:hover {
  color: var(--ss-ink);
}

.btn {
  border: 2px solid var(--ss-line) !important;
  border-radius: 999px !important;
  font-weight: 900 !important;
  box-shadow: 0 5px 0 var(--ss-line);
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.btn:hover,
.btn:focus {
  transform: translateY(-1px);
  box-shadow: 0 6px 0 var(--ss-line);
}

.btn:active {
  transform: translateY(3px);
  box-shadow: 0 2px 0 var(--ss-line);
}

.btn-primary,
.btn-success {
  background: var(--ss-green) !important;
  border-color: var(--ss-line) !important;
  color: var(--ss-ink) !important;
}

.btn-outline-primary {
  background: var(--ss-yellow) !important;
  border-color: var(--ss-line) !important;
  color: var(--ss-ink) !important;
}

.form-control,
.form-select {
  min-height: 3rem;
  border: 2px solid var(--ss-line) !important;
  border-radius: 8px !important;
  background: #fffef8 !important;
  color: var(--ss-ink) !important;
  font-weight: 700;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ss-blue) !important;
  box-shadow: 0 0 0 0.18rem rgba(61, 107, 255, 0.2) !important;
}

.alert {
  border: 2px solid var(--ss-line) !important;
  border-radius: 8px !important;
  color: var(--ss-ink) !important;
  font-weight: 800;
}

.alert-success {
  background: #d9ffd8 !important;
}

.alert-warning {
  background: #fff0a4 !important;
}

.alert-danger {
  background: #ffd8d4 !important;
}

.table {
  color: var(--ss-ink);
  margin-bottom: 0;
}

.table th {
  background: #1d1a13 !important;
  color: #fff8d7 !important;
  border-color: rgba(255, 248, 215, 0.18) !important;
  font-size: 0.78rem;
  letter-spacing: 0;
  text-transform: uppercase;
}

.table td {
  border-color: rgba(22, 20, 15, 0.14) !important;
  font-weight: 700;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 216, 77, 0.18);
}

@media (max-width: 767px) {
  .page-shell {
    width: min(100% - 1rem, 1120px);
    padding-top: 1rem;
  }

  .brand-title {
    font-size: 2.35rem;
  }

  .brand-subtitle {
    font-size: 0.98rem;
  }
}
</style>
